export const KEY_X_AUTH_TOKEN = 'x-auth-token'
export const KEY_X_REFRESH_TOKEN = 'x-auth-refresh-token'

export const SUCCESS_RESPONSE = 0
export const FAILURE_RESPONSE = -1

// component rid
export const CHECKBOX = 1
export const RADIO = 2